import React from "react";
import AppTranslation from "../../service/app_translation/AppTranslation";
import DivisionstActions from "./widget/DivisionstActions";
import { MainBodyContainer } from "../../widget/common/ui/MainContainer";
import Scaffold from "../../widget/layouts/Scaffold";
import DivisionListing from "./widget/DivisionListing";
import { DivisionsContextProvider } from "../../provider/divisions/DivisionsContextProvider";

const DivisionsScreen = (props: { screenMobileView: boolean }) => {
  const screenMobileView: boolean = props.screenMobileView;

  return (
    <DivisionsContextProvider>
      {screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("divisions")}
          appBarAction={<DivisionstActions />}
          isModal={true}
        >
          <MainBodyContainer className="h-100">
            <DivisionListing screenMobileView={screenMobileView} />
          </MainBodyContainer>
        </Scaffold>
      ) : (
        <DivisionListing screenMobileView={screenMobileView} />
      )}
    </DivisionsContextProvider>
  );
};

export default DivisionsScreen;
//export const routeName: string = "/division-list";
